export const UPDATE_STATE_AVAILABLE = 'UPDATE_STATE_AVAILABLE'
export const UPDATE_STATE_IN_PROGRESS = 'UPDATE_STATE_IN_PROGRESS'
export const UPDATE_STATE_SUCCESS = 'UPDATE_STATE_SUCCESS'
export const UPDATE_STATE_ANOMALY = 'UPDATE_STATE_ANOMALY'
